import { Button, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';
import React, { Fragment, ReactNode } from 'react';
import BlankStateImage from './blank-state.svg';

export interface EmptyCommentableProps {
  title: ReactNode;
  description: string;
  action: {
    title: ReactNode;
    testId: string;
    handler(): unknown;
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    padding: theme.spacing(1, 2, 1, 2),
    margin: theme.spacing(4, 0, 0, 0),
  },
  body: {
    padding: theme.spacing(2, 0, 0, 0),
  },
}));

export function EmptyCommentable({ title, description, action }: EmptyCommentableProps) {
  const classes = useStyles();

  return (
    <Grid container data-testid="foo">
      <Grid item xs={6}>
        <Typography color="primary" variant="h5">
          {title}
        </Typography>
        <Typography color="textSecondary" variant="h5" className={classes.body}>
          {description.split('\n').map((text, index) => (
            <Fragment key={index}>
              {text}
              <br />
            </Fragment>
          ))}
        </Typography>
        <Button
          size="medium"
          startIcon={<AddCircle />}
          color="primary"
          className={classes.button}
          data-testid={action.testId}
          component="span"
          onClick={action.handler}
        >
          {action.title}
        </Button>
      </Grid>
      <Grid item xs={6}>
        <img src={BlankStateImage} />
      </Grid>
    </Grid>
  );
}
